import axiosInstance from '../axiosInstance';

export const translationApi = {
    post: (path, params, options, cancelToken) =>
        axiosInstance
            .post(`/translation${path}`, params, {
                ...options,
                cancelToken: cancelToken?.token
            })
            .then((res) => {
                if (res?.data?.error) throw res.data;
                return res?.data;
            })
            .catch((err) => {
                throw err.error ? err : err?.response?.data;
            }),
    get: (path, params, options, cancelToken) =>
        axiosInstance
            .get(
                `/translation${path}`,
                { ...params, ...options },
                {
                    cancelToken: cancelToken?.token
                }
            )
            .then((res) => {
                if (res?.data?.error) throw res.data;
                return res?.data;
            })
            .catch((err) => {
                throw err.error ? err : err?.response?.data;
            })
};

export const getResources = async (params) => translationApi.get('/GetTranslationResources', { params });

export const getSiteLanguages = async (params) => translationApi.get('/GetSiteLanguages');
